import { Text } from '@ui/atoms';
import { cn } from '@ui/atoms/utils/utils';
import React from 'react';

const TopBar = ({ title, description, isAuthorized = false }) => {
    return (
        <div className="flex flex-col">
            <div
                className={cn(
                    'flex flex-col gap-3 md:gap-2 max-w-[305px] mx-auto md:max-w-none md:mx-0 pt-6 pb-4 text-center md:text-left',
                    {
                        'lg:py-8': isAuthorized,
                        'md:py-8': !isAuthorized
                    }
                )}
            >
                <Text
                    content={title}
                    className="text-basicWhite h5-semibold md:h4-semibold"
                />
                <Text
                    content={description}
                    className="text-gray-200 p5-regular"
                />
            </div>
        </div>
    );
};

export default TopBar;
